import { Row, Button, IconButton } from '@fs/zion-ui'
import { TreePedigree, TreeViewRelationship } from '@fs/zion-icon'
import { css } from '@emotion/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import FollowActionSkeleton from './FollowActionSkeleton'

const marginOverrideCss = css`
  & button,
  a {
    margin: 0;
  }
`

type Props = {
  hideText?: boolean
}

export default function BannerActionsSkeleton({ hideText }: Props): JSX.Element {
  const [t] = useTranslation()
  const viewTreeLabel = t('tree-person.view-tree.action')
  const viewRelationshipLabel = t('tree-person.view-relationship.action')

  return (
    <div css={marginOverrideCss}>
      <Row wrap alignY="middle" guttersY="nano" guttersX="xxs">
        {hideText ? (
          <IconButton
            data-testid="view-tree-button"
            Icon={TreePedigree}
            title={viewTreeLabel}
            emphasis="low"
            disabled
          />
        ) : (
          <Button data-testid="view-tree-button" Icon={TreePedigree} emphasis="low" disabled>
            {viewTreeLabel}
          </Button>
        )}
        {hideText ? (
          <IconButton
            data-testid="relationship-viewer-button"
            Icon={TreeViewRelationship}
            title={viewRelationshipLabel}
            emphasis="low"
            disabled
          />
        ) : (
          <Button data-testid="relationship-viewer-button" Icon={TreeViewRelationship} emphasis="low" disabled>
            {viewRelationshipLabel}
          </Button>
        )}
        <FollowActionSkeleton hideText={hideText} />
      </Row>
    </div>
  )
}
